import { trackPlaylistItemNavigation } from '@hotjar/webapp/features/Playbacks/Playlist/utils/playlistTracking';
import { Store } from '../../../store/player/types';
import { goToRecordingByIndex } from './goToRecording';

export const goToRecordingFromPlaylist = (store: Store, recordingId: number): void => {
  const { getRecordingIndexById, recording, user } = store.getState();
  const index = getRecordingIndexById(recordingId);
  goToRecordingByIndex(store, index);
  trackPlaylistItemNavigation(recording, user);
};
